import { render, staticRenderFns } from "./TabSaidasEstrategicas.vue?vue&type=template&id=66e3c65c"
import script from "./TabSaidasEstrategicas.vue?vue&type=script&lang=js"
export * from "./TabSaidasEstrategicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports